import script from "./CreditsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CreditsTable.vue?vue&type=script&setup=true&lang=js"

import "./CreditsTable.vue?vue&type=style&index=0&id=02fe5911&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02fe5911"]])

export default __exports__